import React, { Component } from 'react';
import PropTypes from 'prop-types';

import LottiePlayer from './Players/LottiePlayer';
import Icon from './Icon';

/**
 * SceneHeading
 */

class SceneHeading extends Component {
  constructor(props) {
    super(props);
    this.element = React.createRef();
    this.animation = React.createRef();
  }
  render() {
    // const SceneHeading = ({ title, animationData, icon }) => {
    return (
      <div ref={this.element} className="scene-heading">
        {this.props.animationData && <LottiePlayer ref={this.animation} loop animationData={this.props.animationData} className="scene-animation" />}
        <h2 dangerouslySetInnerHTML={{ __html: this.props.title }} className="scene-title" />
        {this.props.icon && <Icon icon={this.props.icon} />}
      </div>
    );
  }
}

SceneHeading.propTypes = {
  title: PropTypes.string.isRequired,
  animationData: PropTypes.object,
  icon: PropTypes.string,
};

export default SceneHeading;
